(ns client-onboard.views
  (:require
    [reagent.core :as r]
    [css.core :as css :refer [defstyled get-theme]]
    [css.form :as form]
    [css.typography :as typo]
    [cljss.core :as cljss]
    [risk-profile.views :as risk]
    [very.re-frame.core :as rf]
    [priorities.views :as priorities]
    [branding.views :as branding]
    [income.views :as income]
    [expenses.views :as expenses]
    [assets-and-liabilities.views :as a&l]
    [insurance.views :as insurance]
    [client-onboard.common :as coc]
    [estate-and-tax.views :as e&t]
    [key-accomplishments.views :as key-accomplishments]
    [client-onboard.events :refer [step->key key->title]]
    [main.common :as common]
    [profile.common :as pc]))


(defstyled welcome-s :div
  {:text-align "center"
   :display "flex"
   :flex-direction "column"
   :align-items "center"})

(defstyled text-s :p
  {:margin (with-meta #(or % "0") :margin)
   :max-width (with-meta #(or % "100%") :max-width)
   :font-size "1rem"
   :line-height "1.56rem"})

(defstyled welcome-icons-s :div
  {:display "grid"
   :grid-template-columns "1fr 1fr 1fr 1fr"
   :grid-gap "2rem"
   :max-width "50rem"
   :margin "0 auto 4rem"
   ::cljss/media {[[:max-width "768px"]]
                  {:grid-template-columns "1fr 1fr"
                   :grid-row-gap "4rem"}}})

(defstyled welcome-icon-s :div
  {:display "flex"
   :align-items "center"
   :flex-direction "column"
   :font-size "1.25rem"
   :line-height "1.6rem"})

(defstyled circle-icon-s :div
  {:background-color (with-meta identity :background-color)
   :background-image (with-meta #(str "url(/assets/icons/onboarding/" % ".svg)") :icon)
   :background-repeat "no-repeat"
   :width "6.25rem"
   :height "6.25rem"
   :background-position "center"
   :background-size "2rem"
   :border-radius "100%"
   :margin-bottom "1rem"})

(defstyled onboard-s :div
  {:display "grid"
   :min-height "100vh"
   :grid-template-rows "min-content 1fr max-content"
   :grid-template-columns "[left-gutter-start] minmax(1rem, 1fr) [left-gutter-end content-start] minmax(min-content, 82rem) [content-end right-gutter-start] minmax(1rem, 1fr) [right-gutter-end]"})

(defstyled header-s :header
  {:grid-column "content"
   :display "flex"
   :justify-content "space-between"
   :align-items "center"
   :padding "3.25rem 0 5.2rem"})

(defstyled form-wrapper-s :section
  {:grid-column "content"
   :position "relative"})

(defstyled goals-grid-s :div
  {:display "grid"
   :grid-template-columns "1fr 1fr"
   :grid-row-gap "1.5rem"})

(defstyled success-s :div
  {:display "flex"
   :flex-direction "column"
   :max-width "40rem"
   :text-align "center"
   :align-items "center"
   :margin "auto"})

(defn- success []
  [success-s
   [coc/onboarding-header {:step "new"
                           :location 2}]
   [text-s "You have successfully gone through your review, congratulations!"]
   [text-s {:margin "0 0 3rem"} "Now you can access the brand new client experience we have prepared for you."]
   [form/button {:on-click #(rf/>evt [:onboard/finish])
                 :size "large"} "Go to the Client Dashboard"]])

(defn- whats-new [{:keys [on-save on-cancel]}]
  (let [whats-new (rf/subscribe [:review])
        f (atom {})]
    (fn []
      [common/form-page-s
       [common/form-s {:on-submit (fn [e]
                                    (.preventDefault e)
                                    (on-save {:memorable-events (.-value (:memorable-events @f))
                                              :life-decisions (.-value (:life-decisions @f))
                                              :meeting-agenda (.-value (:meeting-agenda @f))}))}
        [common/form-header-s
         [common/form-title-s "Getting ready for your review."]
         [common/form-explain-s "Please answer the questions below to ensure a productive review with your advisor that focuses on your successes, goals, and priorities."]]

        [pc/form-section-s
         [pc/form-section-header-s
          [pc/form-section-title-s "What's new?"]]]

        [form/input-row-s {:margin "3rem 0"}
         [form/input-label-s {:above? true} "1. What is the most memorable thing that's happened over the past 12 months?"]
         [form/textarea-s {:default-value (get @whats-new :memorable-events "")
                           :ref #(swap! f assoc :memorable-events %)
                           :placeholder "Family events? Career events? Large purchases?"}]]

        [form/input-row-s {:margin "3rem 0"}
         [form/input-label-s {:above? true} "2. What life decisions are you contemplating for the next 1, 5, and 10 years? Do any of these keep you up at night?"]
         [form/textarea-s {:default-value (get @whats-new :life-decisions "")
                           :ref #(swap! f assoc :life-decisions %)
                           :placeholder "Changes to your career? Vacations? Purchase of a second home?"}]]

        [form/input-row-s {:margin "3rem 0"}
         [form/input-label-s {:above? true} "3. What are your goals for this meeting? What specifically do you want to make sure we discuss?"]
         [form/textarea-s {:default-value (get @whats-new :meeting-agenda "")
                           :ref #(swap! f assoc :meeting-agenda %)
                           :placeholder "New financial goals? Review your account performance? Changes to legal documents?"}]]
        [form/button-row-s
         [form/secondary-button-s {:type "button"
                                   :on-click on-cancel} "Previous"]
         [form/button {:type "submit"} "Save"]]]])))

(defn- welcome [can-begin?]
  [welcome-s
   [typo/h1 {:margin "0 0 2rem"
             :text-align "center"} "It's that time of the year"]
   [text-s {:max-width "45rem"
            :margin "0 auto 4rem"} "We know how exciting is to review your financial information, so we made it really simple for you. We divided the process into four different categories, each one is color-coded for your reference."]
   [welcome-icons-s
    [welcome-icon-s
     [circle-icon-s {:background-color "#405cd4"
                     :icon "risk"}]
     [:div "Risk Survey"]]
    [welcome-icon-s
     [circle-icon-s {:background-color "#40bcad"
                     :icon "goal"}]
     [:div "Priorities & Goals"]]
    [welcome-icon-s
     [circle-icon-s {:background-color "#f9bb3c"
                     :icon "finances"}]
     [:div "Finances"]]
    [welcome-icon-s
     [circle-icon-s {:background-color "#ea4f3b"
                     :icon "new"}]
     [:div "What's new"]]]

   (when-not can-begin?
     [typo/h2 {:margin "0 0 1rem"} "Loading your profile..."])
   [form/button {:disabled (not can-begin?)
                 :size "large"
                 :on-click #(rf/>evt [:onboard/start])} "Get Started"]])

(defstyled risk-summary-s :div
  {:max-width "52rem"
   :margin "auto"
   :text-align "center"})

(defn- risk-summary [risk]
  [risk-summary-s
   [coc/onboarding-header {:location 7
                           :step "risk"}]
   [risk/risk-profile-summary-text risk true]
   [form/button-row-s
    [form/secondary-button-s {:on-click #(rf/>evt [:onboard/prev])} "Retake Risk Survey"]
    [form/button {:on-click #(rf/>evt [:onboard/next])} "Next"]]])

(defstyled form-navigation-s :div
  {:margin-bottom "4rem"})

(defstyled big-title-s :h1
  {:font-size "4.375rem"
   :margin-top "8rem"
   :text-align "center"
   ::cljss/media {[[:max-width "768px"]]
                  {:font-size "3rem"}}})

(defn- risk-progress' [step]
  [coc/onboarding-header {:location step
                          :step "risk"}])

(defn- active-form [state]
  (let [risk (rf/subscribe [:risk-profile/most-recent])
        priorities (rf/subscribe [:priorities])
        income (rf/subscribe [:income])
        risk-progress (r/atom 0)
        priorities-progress (r/atom 0)]
    (fn [state]
      [form-wrapper-s
       [form-navigation-s
        [big-title-s (get key->title (get step->key (:step state)))]]
       (condp = (get step->key (:step state))
         :splash [welcome (:can-begin? state)]

         :risk/survey
         [:div
          [risk-progress' @risk-progress]
          [risk/risk-survey-form @risk {:on-submit #(rf/>evt [:onboard/update-risk-survey %])
                                        :on-cancel #(rf/>evt [:onboard/prev])
                                        :on-step-change #(reset! risk-progress %)
                                        :cancel-text "Previous"}]]

         :risk/summary [risk-summary @risk]

         :priorities
         [:div
          (condp = @priorities-progress
            0 [coc/onboarding-header {:step "goal"
                                      :location 1}]
            1 [coc/onboarding-header {:step "goal"
                                      :location 2}])
          [priorities/manage-priorities {:on-save #(rf/>evt [:onboard/update-priorities %])
                                         :on-cancel #(rf/>evt [:onboard/prev])
                                         :on-step-change #(reset! priorities-progress %)
                                         :cancel-label "Previous"}]]

         :finances/income
         [:div
          [coc/onboarding-header {:location 1
                                  :step "finances"}]
          [income/income-form @income {:on-save #(rf/>evt [:onboard/update-income %])
                                       :on-cancel #(rf/>evt [:onboard/prev])
                                       :cancel-label "Previous"}]]

         :finances/expenses
         [:div
          [coc/onboarding-header {:step "finances"
                                  :location 2}]
          [expenses/manage {:on-save #(rf/>evt [:onboard/update-expenses %])
                            :on-cancel #(rf/>evt [:onboard/prev])
                            :cancel-label "Previous"}]]

         :finances/assets-&-liabilities
         [:div
          [coc/onboarding-header {:step "finances"
                                  :location 3}]
          [a&l/manage-assets-liabilities {:on-save #(rf/>evt [:onboard/update-assets-and-liabilities %])
                                          :on-cancel #(rf/>evt [:onboard/prev])
                                          :cancel-label "Previous"}]]

         :finances/insurance
         [:div
          [coc/onboarding-header {:step "finances"
                                  :location 4}]
          [insurance/manage-insurance {:on-save #(rf/>evt [:onboard/update-insurance %])
                                       :on-cancel #(rf/>evt [:onboard/prev])
                                       :cancel-label "Previous"}]]

         :finances/estate-&-tax
         [:div
          [coc/onboarding-header {:step "finances"
                                  :location 5}]
          [e&t/manage {:on-save #(rf/>evt [:onboard/update-estate-and-tax %])
                       :on-cancel #(rf/>evt [:onboard/prev])
                       :cancel-label "Previous"}]]

         :whats-new
         [:div
          [coc/onboarding-header {:step "new"
                                  :location 1}]
          [whats-new {:on-save #(rf/>evt [:onboard/update-whats-new %])
                      :on-cancel #(rf/>evt [:onboard/prev])}]]

         :key-accomplishments
         [:div
          [coc/onboarding-header {:step "new"
                                  :location 2}]
          [key-accomplishments/manage {:on-save #(rf/>evt [:onboard/create-key-accomplishments %])
                                       :on-cancel #(rf/>evt [:onboard/prev])}]]

         :success [success]

         ;; TODO shouldn't ever need this, just using it for debugging
         [:div "Unrecognized step"
          [:button {:on-click #(rf/>evt [:onboard/prev])} "Prev"]
          [:button {:on-click #(rf/>evt [:onboard/next])} "Next"]])])))

(defstyled onboard-footer-s :footer
  {:grid-column "span 3"
   :margin-top "8rem"
   :background (get-theme :tertiary)})

(defn main []
  (let [state (rf/subscribe [:onboard/state])]
    (fn []
      [onboard-s
       [header-s
        [branding/logo]
        [form/naked-button-s {:on-click #(rf/>evt [:log-out])} "Log Out"]]
       (if (:step @state)
         [active-form @state]
         [:div "Loading..."])
       [onboard-footer-s
        [branding/footer {:grid-column "span 3"}]]])))
